import React from 'react';
import { BinocularsIcon, FileIcon, NotePencilIcon, TruckIcon } from '@fronton/icons-react';
import {
  ButtonWithGAClickButton,
  LinkWithGAClickButton,
  ReviewsBenefits,
  ReviewsCatalog,
  ReviewsSection,
  Typography,
} from 'common/components';
import { REVIEWS_DATA } from 'common/components/kitchen';
import { fullWidthMobileButton } from 'common/styles/common';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';
import {
  newKitchenReviewsBenefitsLink,
  newKitchenReviewsLink,
} from './new-kitchen-reviews-styles';

type NewKitchenReviewsProps = {
  isRuRegion: boolean;
  signUpHref: string;
};

const BenefitsLink = () => (
  <>
    <span>Сделаем</span>{'\n'}
    <LinkWithGAClickButton
      className={newKitchenReviewsBenefitsLink}
      elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
      elementName="Отзывы клиентов"
      elementText="Запишитесь"
      title="Запишитесь на проектирование"
      href="/uslugi/checkout/?categoryId=1832&measure=true"
      target="_blank">
      <Typography variant="m" size="body_long" color="text-invert">
        точный замер
      </Typography>
    </LinkWithGAClickButton>{' '}
  </>
);

export const NewKitchenReviews: React.FC<NewKitchenReviewsProps> = ({ isRuRegion, signUpHref }) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits
        benefitsList={[
          {
            icon: NotePencilIcon,
            text: isRuRegion ? <BenefitsLink /> : 'Сделаем\nточный замер',
          },
          {
            icon: FileIcon,
            text: 'Подготовим\nдизайн-проект',
          },
          {
            icon: BinocularsIcon,
            text: 'Подберём\nнеобходимую технику',
          },
          {
            icon: TruckIcon,
            text: 'Доставим\nи\u00A0соберём кухню',
          },
        ]}
        newVariant
      />
    }
    description="Делаем кухни, которые хочется показывать"
    review={
      <ReviewsCatalog
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        newVariant
        reviewsList={REVIEWS_DATA}
        modalButton={
          <ButtonWithGAClickButton
            className={fullWidthMobileButton}
            elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
            elementName="Отзывы клиентов"
            elementText="Запишитесь"
            title="Запишитесь на проектирование"
            href={signUpHref}
            target="_blank"
            variant="accent"
            wide
          >
            Записаться на проектирование
          </ButtonWithGAClickButton>
        }
      />
    }
    title={<>
      <LinkWithGAClickButton
        className={newKitchenReviewsLink}
        elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
        elementName="Отзывы клиентов"
        elementText="Запишитесь"
        title="Запишитесь на проектирование"
        href={signUpHref}
        target="_blank">
        <Typography variant="h2" color="text-invert">
          Запишитесь
        </Typography>
      </LinkWithGAClickButton>{' '}
      на&nbsp;бесплатное проектирование, <span>а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах!</span>
    </>
    }
  />
);
